import { MouseEventHandler } from 'react';
import { SkipDirections } from './models/SkipDirections';
import stepBackImage from './images/stepBack.svg';
import stepForwardImage from './images/stepForward.svg';
import style from './styles/App.module.scss';
import { useIntl } from 'react-intl';

export default function SkipButton({ direction, onClick }: { direction: SkipDirections, onClick: MouseEventHandler }) {
    const intl = useIntl();
    let img, txt;
    if (direction === SkipDirections.Backward) {
        img = stepBackImage;
        txt = intl.formatMessage({ id: 'button_description_skip_back_15' });
    } else {
        img = stepForwardImage;
        txt = intl.formatMessage({ id: 'button_description_skip_forward_15' });
    }
    return <button className={style.step} onClick={onClick}>
        <div className={style.clickZone} onClick={onClick} />
        <img src={img} alt={txt} />
    </button>;
}